import clsx from 'clsx'
import { useState } from 'preact/hooks'
import { globalState } from '@/components/helpers/utils'

const isInStock = (variant, stockLevels) => {
  if (!variant) return false
  const quantity = variant.inventory_quantity
  const zeroStockLevel = stockLevels.find(stock => stock.max_quantity === 0)
  if (quantity <= 0 && !zeroStockLevel) return false
  return quantity > 0
}

const getDisplaySize = (variant) => {
  const raw = variant?.option2 || variant?.option1 || variant?.title || ''
  const trimmed = String(raw).trim()
  if (!trimmed || trimmed.toLowerCase() === 'default title') return 'Add to Bag'
  return trimmed
}

export function QuickAddSizeSelector({
  result,
  onAddSuccess,
  className,
  singleVariantLabel = 'Add to Bag',
  buttonClass = 'min-w-[52px]'
}) {
  const variants = Array.isArray(result?.variants) ? result.variants : []
  if (variants.length === 0) return null

  const stockLevels = globalState?.metaobjects.stock_indicators?.sort((a, b) => b.max_quantity - a.max_quantity) || []
  const [loading, setLoading] = useState(false)

  const handleAddToCart = async (variant) => {
    if (loading || !variant?.id || !window.Cart) return
    const variantId = typeof variant.id === 'string' ? parseInt(variant.id, 10) : variant.id
    setLoading(true)
    try {
      await window.Cart.addLineItems({ id: variantId, quantity: 1 })
      onAddSuccess?.()
    } catch (error) {
      console.error('Error adding item to cart:', error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div
      className={clsx('flex items-center justify-center w-full', className, loading && 'opacity-50 cursor-progress')}
      aria-busy={loading}
    >
      <div className={clsx('flex items-stretch w-fit max-w-full overflow-x-scroll no-scrollbar overscroll-x-none', loading && 'pointer-events-none')}>
        {variants.map((variant) => {
          const inStock = isInStock(variant, stockLevels)
          const displaySize = getDisplaySize(variant)
          const buttonLabel = variants.length === 1 ? singleVariantLabel : displaySize
          return (
            <button
              key={variant.id}
              type="button"
              className={clsx(
                'btn btn-transparent btn-primary btn-m whitespace-nowrap !px-0.25',
                buttonClass,
                !inStock && '!text-type-black-tertiary line-through pointer-events-none'
              )}
              onClick={() => handleAddToCart(variant)}
              disabled={!inStock}
              aria-label={variants.length === 1 ? 'Add to bag' : `Add ${displaySize} to bag`}
            >
              {buttonLabel}
            </button>
          )
        })}
      </div>
    </div>
  )
}
